import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-medico-dispensario',
  standalone: true,
  imports: [],
  templateUrl: '../../hero-empresarial/hero-empresarial.component.html',
  styleUrl: './hero-medico-dispensario.component.css'
})
export class HeroMedicoDispensarioComponent {
  name="Medico Dispensario";
  description = "Profesional de la salud disponible dentro de las instalaciones para atender a los empleador";
  description2 = "Se encarga de brindar atención médica básica, realizar evaluaciones de salud, manejar emergencias, y supervisar programas de bienestar laboral";
  routeLogo = "assets/img/enterprise/menu/medicosDispensarios.svg";
  routeImage = "assets/img/enterprise/hero/fotosMedicosDispensario.svg"
}
